import { gql } from '@apollo/client';

export const GetEstateApplicationSchema = gql`
  query GetEstateApplication($estateApplicationId: String!) {
    getEstateApplication(estateApplicationId: $estateApplicationId) {
      value {
        id
        tenantUserId
        estate {
          id
        }
        stage {
          kind
          expiredAt
          coTenants
          tenantCreditStudy
          bondPayment
          rejectionReason
          requirement {
            name
            bondPaymentPercentage
          }
        }
      }
    }
  }
`;
